// src/components/LabelValue.js
import React from "react";
import { Typography } from "antd";
const { Text } = Typography;

const LabelValue = ({ label, value, highlight = false }) => (
  <div className="cii_row">
    <div className="cii_cell">
      <Text>{label}</Text>
    </div>
    <div className="cii_cell">
      <Text>
        <span className={highlight ? "highlight" : ""}>{value}</span>
      </Text>
    </div>
  </div>
);

export default LabelValue;
